import { Table } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Entity } from "@common/types/entity";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { InvoiceViewOptionGroup } from "@common/types/invoice";
import { ScheduleLifecycleRequest } from "@api/scheduleTemplate.api";
import { ViewTableMeta, useViewTableMeta } from "@hooks/view/useViewTableMeta";
import {
    ScheduleApplicationParentRow,
    ScheduleApplicationPeriodRow,
    ScheduleApplicationRow,
} from "./scheduleApplicationRowHelpers";
import { ScheduleBillingRequest } from "./useScheduleBillingActions";

export interface ScheduleApplicationsTableCallbacks {
    onOpenJournalEntry: (options: {
        referenceNumber: string;
        entityId: number;
        ledgerId: string;
        ledgerBasis: AccountingLedgerBasis;
    }) => void;
    onOpenTransaction: (options: {
        transactionId: number;
        entityId: number;
    }) => void;
    onOpenInvoice: (target: {
        invoiceId: string;
        groupBy: InvoiceViewOptionGroup;
    }) => void;
    onOpenBill: (billId: string) => void;
    onRequestLifecycleAction?: (request: ScheduleLifecycleRequest) => void;
    onRequestBillingAction?: (request: ScheduleBillingRequest) => void;
    onOpenInReports?: (row: ScheduleApplicationParentRow) => void;
    onMilestoneAchieved?: (row: ScheduleApplicationPeriodRow) => void;
}

export interface ScheduleApplicationsTableMeta extends ViewTableMeta<
    ScheduleApplicationsTableCallbacks,
    unknown
> {
    entitiesById?: Map<number, Entity>;
}

export function useScheduleApplicationsTableMeta(
    table: Table<ViewTableFeatures, ScheduleApplicationRow>,
): ScheduleApplicationsTableMeta {
    return useViewTableMeta<ScheduleApplicationsTableCallbacks, unknown>(table);
}
